import React from 'react';
import { makeStyles, Theme } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import Typography from '@material-ui/core/Typography';
import AppCard from 'components/@common/Cards/AppCard';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import { PliManagedApp } from 'store/cache/product-cache';

const useStyles = makeStyles((theme: Theme) => {
  return {
    title: {
      marginBottom: theme.spacing(1.5)
    },
    titleContainer: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center'
    },
    cardContainer: {
      display: 'flex',
      justifyContent: 'flex-start',
      flexWrap: 'wrap',
      gap: '30px'
    },
    card: {
      cursor: 'pointer',
      width: '288px'
    },
    media: {
      height: theme.typography.pxToRem(177),
      maxWidth: '100%',
      marginBottom: theme.spacing(0.5),
      backgroundImage: 'linear-gradient(180deg, #FFFFFF 0%, #EEEEEE 100%)'
    }
  };
});

interface TeacherApplicationInformationProps {
  apps: PliManagedApp[];
}

const TeacherApplicationInformation: React.FC<TeacherApplicationInformationProps> = ({ apps }) => {
  const classes = useStyles();
  const { t } = useTranslation('TeacherApplicationInformation');
  const history = useHistory();

  return (
    <>
      <div className={classes.titleContainer}>
        <Typography variant="h2" className={classes.title}>
          {t('Teacher Applications')}
        </Typography>
        <Button
          onClick={(): void => history.push('/app-access')}
          variant="outlined"
          size="small"
          disableElevation
          startIcon={<ArrowForwardIcon />}
        >
          {t('View All Applications')}
        </Button>
      </div>
      <div className={classes.cardContainer}>
        {apps &&
          apps.map(function AccessCard(pliManagedApp: PliManagedApp): React.ReactElement {
            return (
              <AppCard
                key={`app-${pliManagedApp.app.name}${
                  pliManagedApp.appProduct?.product?.code
                    ? `-${pliManagedApp.appProduct.product.code}`
                    : ''
                }`}
                href={
                  pliManagedApp.accessDetails?.url ??
                  `/app-access/${pliManagedApp.appProduct?.product?.code ?? pliManagedApp.app.name}`
                }
                className={classes.card}
                openNew={Boolean(pliManagedApp.accessDetails?.url)}
                src={pliManagedApp.accessDetails?.bannerUrl}
                title={pliManagedApp.title}
                mediaProps={{ className: classes.media }}
              />
            );
          })}
      </div>
    </>
  );
};

export default TeacherApplicationInformation;
